import React, { InputHTMLAttributes} from 'react';

interface FormMembersFieldProps extends InputHTMLAttributes<HTMLInputElement> {
    statusLabel: string
}

const StatusLabel: React.FC<FormMembersFieldProps> = ({ statusLabel, ...rest}) => {
    return (
        <p
            {...rest}
            className={`inline-flex rounded-full dark:bg-opacity-10 py-1 px-3 text-sm font-medium ${
            statusLabel === 'New'
                ? 'bg-request-status-new text-white dark:text-request-status-new'
                : statusLabel === 'Approved'
                ? 'dark:bg-request-status-approved bg-green-700 text-white dark:text-request-status-approved'
                : statusLabel === 'Waitlisted'
                    ? 'dark:bg-request-status-waitlisted bg-yellow-300 text-slate-600 dark:text-request-status-waitlisted'
                    : statusLabel === 'Declined'
                    ? 'bg-request-status-declined text-white dark:text-request-status-declined'
                    : statusLabel === 'Ordered'
                        ? 'bg-request-status-ordered text-white dark:text-request-status-ordered'
                        : statusLabel === 'Delivered'
                        ? 'bg-request-status-delivered text-white dark:text-request-status-delivered'
                        : statusLabel === 'Purchased'
                            ? 'bg-request-status-purchased text-white dark:text-request-status-purchased'
                            : statusLabel === 'Draft'
                                ? 'bg-request-status-draft  text-white dark:text-request-status-draft'
                                : statusLabel === 'DEFAULT'
            }`}
        >
            {statusLabel}
        </p>
    )
}

export default StatusLabel;